/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Make all link children of 'DEMOS' mega menu open in new window
Array.from(document.querySelectorAll('header-details-disclosure .primary-nav__link')).filter((el) => el.textContent.toLowerCase().trim() === 'demos').forEach((el) => {
    Array.from(el.closest('details').querySelectorAll('.cta__link')).forEach((link) => {
        link.setAttribute('target', '_blank'); 
        link.setAttribute('rel','noopener'); 
    });
});
// Make all link children of 'DEMOS' mobile menu open in new window  
Array.from(document.querySelectorAll("drawer-menu .list-menu__link")).filter((el) => el.textContent.toLowerCase().trim() === 'demos').forEach((el) => {
    Array.from(el.closest('details').querySelectorAll('.cta__link')).forEach((link) => {
        link.setAttribute('target', '_blank'); 
        link.setAttribute('rel','noopener'); 
    });
});